// extracted by mini-css-extract-plugin
export default {"container":"layout_container__BYz4T","rightTitle":"layout_rightTitle__qpyfu"};